export const generateWhatsAppLink = (phone, message) => {
  const cleanPhone = phone.replace(/[^0-9]/g, '');
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${cleanPhone}?text=${encodedMessage}`;
};

export const generateInvoiceMessage = (invoice, designerName, upiId) => {
  let message = `*Invoice from ${designerName}*\n\n`;
  message += `Invoice #: ${invoice.invoice_number}\n`;
  message += `Date: ${new Date(invoice.created_at).toLocaleDateString()}\n\n`;
  message += `*Items:*\n`;
  
  invoice.items.forEach(item => {
    message += `${item.service_name} x ${item.quantity} @ ₹${item.rate} = ₹${item.total}\n`;
  });
  
  message += `\n*Total: ₹${invoice.total}*\n`;
  
  if (invoice.advance_paid > 0) {
    message += `Advance Paid: ₹${invoice.advance_paid}\n`;
    message += `*Balance: ₹${invoice.balance}*\n`;
  }
  
  if (invoice.notes) {
    message += `\nNotes: ${invoice.notes}\n`;
  }
  
  if (upiId) {
    message += `\nPay via UPI: ${upiId}`;
  }
  
  return message;
};

export const generatePaymentReminderMessage = (customerName, invoice) => {
  return `Hi ${customerName},\n\nGentle reminder for pending payment:\n\nInvoice #: ${invoice.invoice_number}\nAmount Due: ₹${invoice.balance}\n\nThank you!`;
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(amount);
};

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const getStatusColor = (status) => {
  const colors = {
    new: 'bg-blue-100 text-blue-800',
    contacted: 'bg-yellow-100 text-yellow-800',
    quoted: 'bg-purple-100 text-purple-800',
    converted: 'bg-green-100 text-green-800',
    pending: 'bg-red-100 text-red-800',
    partial: 'bg-yellow-100 text-yellow-800',
    paid: 'bg-green-100 text-green-800',
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
};